<template>
    <div>
        <home-section-title :text="title"/>
        <!-- <v-container class="pt-0 px-4 mb-6"> -->
            <v-slide-x-reverse-transition>
                <v-row class="px-4">
                    <v-col class="home__discover-item" v-for="(item, i) in orderedItems"
                           :key="i"
                           cols="4">
                        <div class="d-flex justify-center">
                            <home-gallery-item
                                :item="item"
                                :id="item.id"
                                :star="false"
                                @click="refClass ? handleStreamsButtonClick(item) : handleClickGalleryItem(i)"
                                class="discover-home-gallery-items"
                                :custom-size="86"
                                :circle="circle"
                                :streamIcon="streamIcon"
                            />
                        </div>
                    </v-col>
                </v-row>
            </v-slide-x-reverse-transition>
        <!-- </v-container> -->
    </div>
</template>

<script>
import HomeSectionTitle from '@/components/app/home/HomeSectionTitle';
import HomeGalleryItem from '@/components/app/home/HomeGalleryItem';
import { mapActions, mapState } from "vuex";
import _ from "lodash";

export default {
    name: "HomeDiscover",
    components: {
        HomeSectionTitle,
        HomeGalleryItem
    },
    props: {
        title: {
            type: String,
            default: ''
        },
        items: {
            type: [Array, Object],
            default: () => []
        },
        circle: {
            type: Boolean,
            default: false
        },
        refClass: {
            type: Boolean,
            default: false
        },
        streamIcon: {
            type: Boolean,
            default: false
        },
    },
    computed: {
        ...mapState({
            currentUser: (state) => state.user.user.data,
        }),
        orderedItems() {
            return _.orderBy(this.items, 'order', 'desc')
        },
        orderedItemsHasStories() {
            return this.orderedItems.filter((item) => {
                return item.has_stories > 0
            })
        },
    },
    methods: {
        ...mapActions([
            "setOtherUser",
            "setOtherUserBySlug",
        ]),
        handleClickGalleryItem(index) {
            this.$emit('click',{
                items: this.orderedItemsHasStories,
                index: index,
            })
        },
        async handleStreamsButtonClick(item) {
            const ageVerify = this.$core.storyCore.ageVerification(this.currentUser);
            if(!ageVerify)  return [];
            this.loading = true;
            const promise =
                typeof this.$route.params.slug !== "undefined"
                    ? this.setOtherUserBySlug(item.slug)
                    : this.setOtherUser(item.id);

            await promise.catch(() => {
                this.$router.push({ name: "404" });
            });

            if (!!item.slug) {
                this.$router.push({
                    name: "otherUser.profile.viewStreams",
                    params: { slug: item.slug },
                    query: { fromHome: true },
                });
                return;
            }
        },
    }
}
</script>

<style lang="scss">
.home__discover-item {
  z-index: 1;
  box-sizing: border-box;

  div {
    .discover-home-gallery-items {
        margin-left: 5px;
    }
  }
}
</style>
